import { StorageHandler } from "./storage-handler";
import { IStorageHandler } from "../storage-handler.interface";
import * as localForage from "localforage";

export class LocalStorageHandler extends StorageHandler implements IStorageHandler {

    private storage: LocalForage;

    constructor(public readonly key: string) {
        super("Local", key);

        this.storage = localForage.createInstance({
            name: key,
            driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE]
        });
    }

    setItem(key: string, value: any): Promise<any> {
        return this.storage.setItem(key, value);
    }

    getItem(key: string): Promise<any> {
        return this.storage.getItem(key);
    }

    removeItem(key: string): Promise<any> {
        return this.storage.removeItem(key);
    }

    clear(): Promise<any> {
        return this.storage.clear();
    }

    keys(): Promise<Array<string>> {
        return this.storage.keys();
    }

    length(): Promise<number> {
        return this.storage.length();
    }

    forEach(iteratorCallback: (value: any, key: string, iterationNumber: Number) => any): Promise<null> {
        return this.storage.iterate(iteratorCallback);
    }

}



// WEBPACK FOOTER //
// ./src/core/services/storage/handlers/local-storage-handler.ts